import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ContractInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UpdateContractUseCaseParams {
    contract: ContractInterface;
}

@Injectable()
export class UpdateContractUseCase implements UseCaseWithParam<UpdateContractUseCaseParams, Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(params: UpdateContractUseCaseParams): Observable<Transaction<void>> {
        return this.contractProvider.update(params.contract);
    }
}
